<template>
  <span
    class="digital-signature-pill"
    :class="`is-${signature.status}`"
    :title="signature.error || null"
  >
    <fa-icon :icon="['fal', icon]" :spin="isRunning" />
    {{ label }}
  </span>
</template>

<script>
import {
  FAILED,
  SIGNED,
  getName,
  isRunning,
} from '@/data/digital-signature';

export default {
  props: {
    signature: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isRunning() {
      return isRunning(this.signature);
    },
    icon() {
      if (this.signature.status === SIGNED) return 'shield-check';
      if (this.signature.status === FAILED) return 'exclamation-triangle';
      return 'sync';
    },
    label() {
      return getName(this.signature.status);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.digital-signature-pill {
  align-items: center;
  background-color: $light-color;
  border: $border-width solid #F2C94C;
  border-radius: 1rem;
  color: darken($warning-color, 15%);
  display: inline-flex;
  font-size: $font-size-sm;
  gap: .2rem;
  line-height: 1.2;
  padding: .1rem .45rem;
  white-space: nowrap;
  &.is-signed {
    border-color: #BFE3CD;
    color: #1F7A4E;
  }
  &.is-failed {
    border-color: #F1C4C4;
    color: $error-color;
  }
}
</style>
